import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CorteDiarioModel } from '../corte-diario.models';

@Component({
  selector: 'modal-factura',
  templateUrl: './modal-factura.component.html',
  styleUrls: ['./modal-factura.component.css'],
})
export class ModalFacturaComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      gestionSelected: CorteDiarioModel.GetGestionesAbiertasXRutas;
      usuarioid: string;
      listFacturas: Array<{ NumeroFactura: string }>;
    }
  ) {}

  ngOnInit(): void {}
}
